<template>
    <div class="w-full space-y-3">
        <Head title="Reports"/>
        <div class="flex justify-between">
            <h1 class="mt-2 text-2xl font-bold leading-7 text-gray-900 sm:text-3xl">Unit 4 Gap Report</h1>
            <a :href="route('frontend.reports.operational_unit_4_gap_report_export', {
                _query: {
                    starts_at: form.starts_at,
                    ends_at: form.ends_at,
                    fixture_type: form.fixture_type
                }})" class="py-3 px-3 border border-transparent shadow-sm text-sm leading-4 rounded-md text-white bg-pitch-purple focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amaze-coral w-40 text-center">Download</a>
        </div>
    </div>
    <br />
    <div class="grid grid-cols-3 gap-2">
        <div class="relative">
            <label for="start-date" class="block text-sm font-medium text-gray-700">Start Date</label>
            <input v-model="form.starts_at" name="start-date" type="date" class="mt-2 bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 datepicker-input" placeholder="Select start date">
        </div>
        <div class="relative">
            <label for="end-date" class="block text-sm font-medium text-gray-700">End Date</label>
            <input v-model="form.ends_at" name="end-date" type="date" class="mt-2 bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 datepicker-input" placeholder="Select end date">
        </div>
        <div class="relative">
            <label for="invoice_status_manager" class="block text-sm font-medium invisible">Fixture Type</label>
            <select id="invoice_status_manager" name="invoice_status_manager"
                    class="block w-full h-10 mt-2 bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm"
                    v-model="form.fixture_type">
                <option value selected>Fixture Type</option>
                <option v-for="fixture_type in fixture_types" :value="fixture_type.id">
                    {{ fixture_type.name }}
                </option>
            </select>
        </div>
    </div>
    <br />
    <div class="bg-white py-6 px-4 sm:p-6 shadow mb-6">
        <div class="flex flex-col mt-3 space-y-3">
            <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead class="bg-gray-50">
                                <tr>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Fixture Name
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Client
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Total Quote
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Total Paid
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Total Unpaid
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Total Outstanding
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Commission Expected
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Commission Raised
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="Object.values(fixtures).length > 0" v-for="(fixture, index) in fixtures" :key="index">
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <a>
                                            {{ fixture.title }}
                                        </a>
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <a>
                                            {{ fixture.client.name }}
                                        </a>
                                    </td>
                                    <td v-if="fixture.total_quote == 0" class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <a>
                                            £0.00
                                        </a>
                                    </td>
                                    <td v-else class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <a>
                                            £{{ fixture.total_quote }}
                                        </a>
                                    </td>
                                    <td v-if="fixture.total_paid == 0" class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <a>
                                            £0.00
                                        </a>
                                    </td>
                                    <td v-else class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <a>
                                            £{{ fixture.total_paid }}
                                        </a>
                                    </td>
                                    <td v-if="fixture.total_unpaid == 0" class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <a>
                                            £0.00
                                        </a>
                                    </td>
                                    <td v-else class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <a>
                                            £{{ fixture.total_unpaid }}
                                        </a>
                                    </td>
                                    <td v-if="fixture.total_unpaid == 0" class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <a>
                                            £0.00
                                        </a>
                                    </td>
                                    <td v-else class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <a>
                                            £{{ fixture.total_unpaid }}
                                        </a>
                                    </td>
                                    <td v-if="fixture.total_commission_expected == 0" class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <a>
                                            £0.00
                                        </a>
                                    </td>
                                    <td v-else class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <a>
                                            £{{ fixture.total_commission_expected }}
                                        </a>
                                    </td>
                                    <td v-if="fixture.total_commission_raised == 0" class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <a>
                                            £0.00
                                        </a>
                                    </td>
                                    <td v-else class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <a>
                                            £{{ fixture.total_commission_raised }}
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Authenticated from "@/Layouts/Authenticated";
    import {Link, Head, useForm} from "@inertiajs/vue3";
    import Pagination from "@/Components/Pagination";
    import mapValues from "lodash/mapValues";
    import debounce from "lodash/debounce";
    import pickBy from "lodash/pickBy";

    export default {
        layout: Authenticated,
        components: {
            Head,
            Link,
            Pagination
        },
        props: ['starts_at', 'ends_at', 'fixture_types', 'fixtures', 'fixture_type_id'],
        data(props) {
            return {
                form: {
                    starts_at: props.starts_at,
                    ends_at: props.ends_at,
                    fixture_type: props.fixture_type_id
                }
            }
        },
        methods: {
            reset() {
                this.form = mapValues(this.form, () => null)
            },
        },
        watch: {
            form: {
                deep: true,
                handler: debounce(function () {
                    this.$inertia.get(route('frontend.reports.operational_unit_4_gap_report'), pickBy(this.form), {preserveState: true, preserveScroll: true})
                }, 500),
            },
        }
    }
</script>
